import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Page, Pagination } from '../../../../shared/models/page';
import { ColumnMode, NgxDatatableModule } from '@swimlane/ngx-datatable';
import { debounceTime, distinctUntilChanged, filter, finalize, Subject, switchMap } from 'rxjs';
import { RolesService } from '../../../../core/services/roles.service';
import { MatDialog } from '@angular/material/dialog';
import { Role, RoleFilters, RoleWithUserCount } from '../../../../shared/models/role';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxPermissionsModule } from 'ngx-permissions';
import { CargoUserListDialogComponent } from '../../dialogs/cargo-user-list-dialog/cargo-user-list-dialog.component';
import { Router } from '@angular/router';
import { LoadingService, LocalLoadingState } from '../../../../core/services/loading.service';

@Component({
  selector: 'app-cargos-lista',
  imports: [
    MatIconModule,
    CommonModule,
    NgxDatatableModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    NgxPermissionsModule,
  ],
  templateUrl: './cargos-lista.component.html',
  styleUrl: './cargos-lista.component.scss'
})
export class CargosListaComponent implements OnInit, OnDestroy {
  private loadPageSubject = new Subject<RoleFilters>();
  private loader: LocalLoadingState;

  cargos! : RoleWithUserCount[];

  columns = [
      { prop: 'cargo', name: 'Cargo' },
      { prop: 'totalUsers', name: 'Usuários' },
      { name: 'Ações' }
    ];
  ColumnMode = ColumnMode;
  page: Page = { pageSize: 10, page: 0, count:0 };
  sort : string = "normal";

  searchControl = new FormControl('');

  get isLoading(): boolean {
    return this.loader.isLoading();
  }

  constructor(
    private rolesService: RolesService,
    private dialog: MatDialog,
    private router: Router,
    private loadingService: LoadingService,
  ) {
    this.loader = this.loadingService.createLocalLoader();
  }

  ngOnInit() {
      this.loadPageSubject.pipe(
        switchMap((produtosFilters: RoleFilters) => {
          this.loader.show();
          return this.rolesService.getRoles(produtosFilters).pipe(
            finalize(() => this.loader.hide())
          );
        })
      ).subscribe((pagedData) => {
        this.page.count = pagedData.totalCount;
        this.cargos = pagedData.items;
      });
  
      this.loadPage();
  
      this.searchControl.valueChanges
        .pipe(
          debounceTime(1000),
          distinctUntilChanged(),
          filter(() => !this.isLoading),
        )
        .subscribe((searchValue) => {
          this.page.page = 0;
          this.loadPage();
        });
    }

  onSearchKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.page.page = 0;
      this.loadPage();
    }
  }

  changePageSize(event: Event) {
    const newSize = (event.target as HTMLSelectElement).value;
    this.page.pageSize = parseInt(newSize, 10);
    this.page.page = 0;
    this.loadPage();
  }

  onPage(event: { offset: number }) {
    this.page.page = event.offset;
    this.loadPage();
  }

  onSort(event: { sorts: { prop: string, dir: string }[] }) {
    const sort = event.sorts[0];
    this.sort = sort.dir === 'asc' ? 'normal' : 'reverse';
    this.page.page = 0;
    this.loadPage();
  }

  loadPage() {
    const filters: RoleFilters = {
      sort: this.sort,
      page: this.page.page + 1,
      pageSize: this.page.pageSize,
      name: (this.searchControl.value != null && this.searchControl.value.trim() !== '') ? this.searchControl.value : undefined,
    };
    this.loadPageSubject.next(filters);
  }

  openUserListDialog(cargoId: number){
    const dialogData = {
      cargoId: cargoId,
    };

    const dialogRef = this.dialog.open(CargoUserListDialogComponent, {
      data: dialogData,
      maxHeight: '80vh',
    });
}
  
  onRowClick(event: any){
    if (event.type === 'click') {
      this.editPermissoes(event.row.id);
    }
  }

  editPermissoes(cargoId: number){
    this.router.navigate([`cargos/permissoes`, cargoId]);
  }

  novoCargo(){
    this.router.navigate(['cargos/permissoes']);
  }

  ngOnDestroy(): void {
    this.loader.destroy();
  }
}
